export interface PaymentExtractData {
  clientId: string;
  entityId: string;
  clientTaxPeriodId: number;
  periodBegin: Date | null;
  periodEnd: Date | null;
  state: string;
  returnName: string;
  registrationNumber: string;
  locationCode: string;
  taxType: string;
  amount: number;
  total: number;
  periodBeginDisplay: string;
  periodEndDisplay: string;
}
